// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--JreNK";
export var heroImage = "hero-module--heroImage--NL-O0";
export var heroDetails = "hero-module--heroDetails--xCojk";
export var heroHeadline = "hero-module--heroHeadline--j56rL";
export var heroTitle = "hero-module--heroTitle--UcXZX";